import { render, staticRenderFns } from "./EventPurchase.vue?vue&type=template&id=6b0e257a&scoped=true&"
import script from "./EventPurchase.vue?vue&type=script&lang=js&"
export * from "./EventPurchase.vue?vue&type=script&lang=js&"
import style0 from "./EventPurchase.vue?vue&type=style&index=0&id=6b0e257a&prod&scoped=true&lang=css&"
import style1 from "./EventPurchase.vue?vue&type=style&index=1&id=6b0e257a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e257a",
  null
  
)

export default component.exports